import * as z from "zod";

export const transportTypeSchema = z.enum([
  "BUS",
  "METRO",
  "TRAIN",
  "TRAM",
  "SHIP",
]);

export const LineGroup = z.enum([
  "Tunnelbanans blå linje",
  "Tunnelbanans röda linje",
  "Tunnelbanans gröna linje",
  "Spårväg City",
  "Nockebybanan",
  "Lidingöbanan",
  "Tvärbanan",
  "Pendeltåg",
  "Saltsjöbanan",
  "Roslagsbanan",
  "Blåbuss",
  "Rödbus",
  "Närtrafiken",
  "Ersättningsbuss",
  "Pendelbåt",
  "Lisen/Lotten",
  "Fjäderholmslinjen",
  "Annat",
  "Waxholmsbolaget",
]);

export type TransportType = z.infer<typeof transportTypeSchema>;
export type LineGroup = z.infer<typeof LineGroup>;
export const lineSchema = z.object({
  id: z.number(),
  designation: z.string().optional(),
  transport_mode: transportTypeSchema.optional(),
  group_of_lines: LineGroup.optional(),
});

export type Line = z.infer<typeof lineSchema>;
